export default __webpack_public_path__ + "static/media/mons15.e7943882.jpg";